import { REF_VIEWPORT_HEIGHT, REF_VIEWPORT_WIDTH } from "../constants/misc";
export function getHeightByViewPort(valueInPx: number) {
    return `${(valueInPx / REF_VIEWPORT_HEIGHT) * (Math.max(window.screen.availHeight, 640) - 110)}px`;
}

export function getWidthByViewPort(valueInPx: number) {
    return `${(valueInPx / REF_VIEWPORT_WIDTH) * window.screen.availWidth}px`;
}
